import apiClient from './api-client';

export default {
  searchPredictions(searchTerm, langCode) {
    return apiClient.get(`/search/${langCode}/autosuggest?searchTerm=${searchTerm}`);
  },
};
